import * as React from "react";

import { Page, PageHero, Tabs } from "src/components/common";

interface IProps {
	history?: any;
	children?: any;
	match?: any;
	location?: any;
	disabled?: boolean;
}

const CoreTabs: React.FC<IProps> = (props) => {
	const { organizationId, datasetId, clientId, coreId, sessionId } =
		props.match.params;

	const coreURL = `/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/sessionId/${sessionId}/core/${coreId}`;

	const tabs = [
		{
			to: `${coreURL}/general-appraisal`, // its name of route without slash
			label: "General",
		},
		{
			to: `${coreURL}/skills-appraisal`,
			label: "Skills appraisal",
		},
		{
			to: `${coreURL}/excelerate`,
			label: "Error entry",
		},
	];

	return (
		<React.Fragment>
			<Page>
				<PageHero>
					<h1 className="mb-0">On-Road</h1>
				</PageHero>
				<Tabs
					className="mb-4"
					tabs={tabs}
					location={props.location}
					disabled={props.disabled}
				/>
				{props.children}
			</Page>
		</React.Fragment>
	);
};

export default CoreTabs;
